import { gql } from '@apollo/client';

export const MEDICAL_RECORDS_ANNOUNCEMENT_SETTINGS = gql`
  query medicalRecordsAnnouncementSettings {
    patientUiSettings {
      id
      medicalRecordsAnnouncementDismissed
    }
  }
`;

export const DISMISS_MEDICAL_RECORDS_ANNOUNCEMENT = gql`
  mutation dismissMedicalRecordsAnnouncement {
    dismissMedicalRecordsAnnouncement {
      patientUiSettings {
        id
        medicalRecordsAnnouncementDismissed
      }
    }
  }
`;
